var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsedDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2333 36.0334C28.7666 36.4667 27.0333 36.6667 24.9999 36.6667H14.9999C12.9666 36.6667 11.2333 36.4667 9.7666 36.0334C10.1333 31.7 14.5833 28.2833 19.9999 28.2833C25.4166 28.2833 29.8666 31.7 30.2333 36.0334Z",
    fill: "#F0A328",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 3.33337H15.0002C6.66683 3.33337 3.3335 6.66671 3.3335 15V25C3.3335 31.3 5.2335 34.75 9.76683 36.0334C10.1335 31.7 14.5835 28.2833 20.0002 28.2833C25.4168 28.2833 29.8668 31.7 30.2335 36.0334C34.7668 34.75 36.6668 31.3 36.6668 25V15C36.6668 6.66671 33.3335 3.33337 25.0002 3.33337ZM20.0002 23.6167C16.7002 23.6167 14.0335 20.9334 14.0335 17.6334C14.0335 14.3334 16.7002 11.6667 20.0002 11.6667C23.3002 11.6667 25.9668 14.3334 25.9668 17.6334C25.9668 20.9334 23.3002 23.6167 20.0002 23.6167Z",
    fill: "#F0A328",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9665 17.6333C25.9665 20.9333 23.2999 23.6166 19.9999 23.6166C16.6999 23.6166 14.0332 20.9333 14.0332 17.6333C14.0332 14.3333 16.6999 11.6666 19.9999 11.6666C23.2999 11.6666 25.9665 14.3333 25.9665 17.6333Z",
    fill: "#F0A328",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsedDashboard);
export default __webpack_public_path__ + "static/media/used-dashboard.1b233a83080a15717f53e09a849f0212.svg";
export { ForwardRef as ReactComponent };